import React, { useState } from "react";
import { motion } from "framer-motion";

const POINTS = [
  { label: "60 A", scale: "A", de: "Sehr weich – Dichtungen, Dämpfer", en: "Very soft – seals, dampers" },
  { label: "70 A", scale: "A", de: "Weich – flexible Schläuche", en: "Soft – flexible tubing" },
  { label: "80 A", scale: "A", de: "Mittel – Folien, Profile", en: "Medium – films, profiles" },
  { label: "85 A", scale: "A", de: "Standard – Schläuche, Kabel", en: "Standard – tubing, cables" },
  { label: "90 A", scale: "A", de: "Fest – Rollen, Verschleißteile", en: "Firm – rollers, wear parts" },
  { label: "95 A", scale: "A", de: "Hart – belastete Bauteile", en: "Hard – loaded components" },
  { label: "50 D", scale: "D", de: "Sehr hart – steife technische Teile (≈ 98 A)", en: "Very hard – rigid technical parts (≈ 98 A)" },
  { label: "60 D", scale: "D", de: "Hart & steif – Strukturbauteile", en: "Hard & stiff – structural parts" },
  { label: "70 D", scale: "D", de: "Sehr steif – hochbelastete Bauteile", en: "Very stiff – highly loaded parts" },
  { label: "80 D", scale: "D", de: "Maximale Härte – starre technische Bauteile", en: "Maximum hardness – rigid technical parts" },
];

const A_COUNT = POINTS.filter((p) => p.scale === "A").length;

export function ShoreScale({ lang = "de" }) {
  const [active, setActive] = useState(3);
  const pct = (active / (POINTS.length - 1)) * 100;
  const dividerPct = ((A_COUNT - 0.5) / (POINTS.length - 1)) * 100;

  return (
    <div data-testid="shore-scale" className="w-full">
      <div className="flex justify-between text-xs font-mono text-[#4a4d52] mb-2">
        <span>60 Shore A · {lang === "de" ? "weich" : "soft"}</span>
        <span>80 Shore D · {lang === "de" ? "hart" : "hard"}</span>
      </div>
      <div className="relative h-3 rounded-full bg-gradient-to-r from-[#FBEADD] via-[#F0A26A] to-[#16181D]">
        {/* A | D divider */}
        <div className="absolute top-1/2 h-5 w-px -translate-y-1/2 bg-white/70" style={{ left: `${dividerPct}%` }} />
        <motion.div
          className="absolute -top-1.5 h-6 w-6 rounded-full bg-white border-2 border-[#E2611C] shadow-lg"
          animate={{ left: `calc(${pct}% - 12px)` }}
          transition={{ type: "spring", stiffness: 200, damping: 22 }}
        />
      </div>
      <div className="mt-2 flex justify-between text-[10px] uppercase tracking-wider text-[#4a4d52]">
        <span>Shore A (60–95)</span>
        <span>Shore D (50–80)</span>
      </div>

      <div className="mt-6 grid grid-cols-5 gap-2 sm:grid-cols-10">
        {POINTS.map((p, i) => (
          <button
            key={p.label}
            data-testid={`shore-${p.label.replace(" ", "")}`}
            onClick={() => setActive(i)}
            className={`rounded-lg border px-1.5 py-2 text-xs font-medium transition-all sm:text-sm ${
              i === active
                ? "border-[#E2611C] bg-[#FBEADD] text-[#16181D]"
                : p.scale === "D"
                ? "border-[#e4e9f0] bg-[#f6f8fb] text-[#4a4d52] hover:border-[#E2611C]"
                : "border-[#e4e9f0] text-[#4a4d52] hover:border-[#E2611C]"
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>
      <motion.p key={active} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} className="mt-4 text-[#4a4d52]">
        <span className="font-mono font-semibold text-[#16181D]">{POINTS[active].label.replace(" ", " Shore ")}</span> — {lang === "de" ? POINTS[active].de : POINTS[active].en}
      </motion.p>
      <p className="mt-2 text-xs text-[#4a4d52]">
        {lang === "de"
          ? "Die Shore-A-Skala reicht bis 95 A; darüber wird die Härte in Shore D angegeben (bis 80 D für starre Bauteile)."
          : "The Shore A scale goes up to 95 A; above that hardness is expressed in Shore D (up to 80 D for rigid parts)."}
      </p>
    </div>
  );
}
